module.exports = __webpack_public_path__ + "static/media/transformation.759cab12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/transformation.jpg
// module id = 382
// module chunks = 0